<template>
    <div id="">
         <div class="container-fluid  bg-primary ">
            <div class="page-title">
              <div class="row">
                <div class="col-12">
                 <img class="img-fluid for_logo" src="../../../assets/images/logo/hcelogo.png"
                                    alt="looginpage">
                </div>
               
              </div>
            </div>
          </div>
      <MobileQRScanner />
    </div>
  </template>
  
  <script> 
  import MobileQRScanner from '@/components/MobileQRScanner.vue'
  
  export default { 
    components: {
        MobileQRScanner
    }
  }
  </script>
  
  <style>
  /* Add any global styles if needed */
  </style>
  